import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import instaFooter from "../../../assets/icons/instaFooter.png";
import XFooter from "../../../assets/icons/XFooter.png";
import LinkDinFooter from "../../../assets/icons/linkdinFooter.png";
import facebookFooter from "../../../assets/icons/fbFooter.png";

const Footer = () => {
  return (
    <div className="footer-main">
      {" "}
      <footer>
        <div className="socialMedia-box">
          <Link to="" className="socialMedia-links">
            <img src={facebookFooter} alt="" />
          </Link>
          <Link to="" className="socialMedia-links">
            <img src={LinkDinFooter} alt="" />
          </Link>
          <Link to="" className="socialMedia-links">
            <img src={XFooter} alt="" />
          </Link>
          <Link to="" className="socialMedia-links">
            <img src={instaFooter} alt="" />
          </Link>
        </div>
        <div className="copyRight-box">@2023 AutoRed. All Rights Reserved</div>
        <div className="terms-box">
          <Link to="" className="terms-links">
            Terms & Conditions
          </Link>
          <Link to="" className="terms-links">
            Contact us
          </Link>
          <Link to="" className="terms-links">
            Privacy Policy
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
